define([
    "./nlgTableauVizModule",
    "./nlgTableauVizDirective",
    "./tableauServiceUrl"
], function () {
});